export const AUTOSHIP_CONTENT_KEY = 'autoship-content';
export const AUTOSHIP_MAP_RESTRICTED_CONTENT_KEY = 'autoship-map-restricted-content';
